import { render, staticRenderFns } from "./SortableGrid.vue?vue&type=template&id=ad2cb5f0&scoped=true"
import script from "./SortableGrid.vue?vue&type=script&lang=js"
export * from "./SortableGrid.vue?vue&type=script&lang=js"
import style0 from "./SortableGrid.vue?vue&type=style&index=0&id=ad2cb5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2cb5f0",
  null
  
)

export default component.exports